<template>
  <div class="language-box">
    <img class="image is-16x16" src="@/assets/images/flags/fr.png" v-on:click="changeLocale('fr')"/>
    <img class="image is-16x16" src="@/assets/images/flags/en.png" v-on:click="changeLocale('en')"/>
  </div>
</template>

<script>
export default {
  methods: {
    changeLocale (language) {
      this.$i18n.locale = language
      window.localStorage.setItem('language', language)
    }
  }
}
</script>

<style scoped>
  .language-box {
    width: 70px;
  }
  .language-box img {
    display: inline-block;
    cursor: pointer
  }
</style>



// WEBPACK FOOTER //
// src/components/SwitchLanguage.vue